import React from "react";

const Wrapper = (props) => <main className="wrapper" {...props} />;

export default Wrapper;
